<template>
  <div class="app-container">
    <div class="filter-container">
      <!--      <el-button class="filter-item" type="primary" icon="el-icon-edit" @click="handleCreate" size="small">添加-->
      <!--      </el-button>-->

      <el-input
        v-model="listQuery.id"
        placeholder="ID"
        style="width: 120px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-input
        v-model="listQuery.name"
        placeholder="名称"
        style="width: 200px"
        class="filter-item"
        size="small"
        clearable
      />
      <el-select
        v-model="listQuery.cooperation_type"
        placeholder="合作类型"
        clearable
        style="width: 140px"
        class="filter-item"
        size="small"
      >
        <el-option label="账期合作" value="account_term" />
        <el-option label="预充值合作" value="advance_recharge" />
        <el-option label="企业现付" value="enterprise_cash_payment" />
      </el-select>
      <el-select
        v-model="listQuery.is_normal"
        placeholder="状态"
        clearable
        style="width: 90px"
        class="filter-item"
        size="small"
      >
        <el-option label="正常" value="1" />
        <el-option label="禁用" value="0" />
      </el-select>
      <el-button
        class="filter-item"
        type="primary"
        icon="el-icon-search"
        @click="handleFilter"
        size="small"
        >搜索
      </el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      element-loading-text="Loading"
      border
      fit
      highlight-current-row
      size="small"
    >
      <el-table-column align="center" label="ID" width="95">
        <template slot-scope="scope">
          <!-- {{ scope.$index }} -->
          {{ scope.row.id }}
        </template>
      </el-table-column>
      <el-table-column label="客户名称" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>
      <el-table-column label="合作类型" min-width="110" align="center">
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.cooperation_type === 'account_term'"
            type="primary"
            >账期合作</el-tag
          >
          <el-tag
            v-else-if="scope.row.cooperation_type === 'advance_recharge'"
            type="success"
            >预充值合作</el-tag
          >
          <el-tag
            v-else-if="scope.row.cooperation_type === 'enterprise_cash_payment'"
            type="info"
            >企业现付</el-tag
          >
          <el-tag v-else type="warning">-</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="临时额度" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.accounts ? scope.row.accounts.temporary_quota : 0 }}
        </template>
      </el-table-column>
      <el-table-column label="剩余额度" min-width="120" align="center">
        <template slot-scope="scope">
          <el-tag
            :class="['balance-tag', 'balance-' + balanceLevel(scope.row)]"
          >
            {{ scope.row.accounts ? scope.row.accounts.available_quota : 0 }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="对账可开票金额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.accounts ? scope.row.accounts.balance : 0 }}
        </template>
      </el-table-column>
      <el-table-column label="已对账总额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.paid_total_channel_money }}
        </template>
      </el-table-column>
      <el-table-column label="已充值总额" min-width="110" align="center">
        <template slot-scope="scope">
          {{ scope.row.total_recharge_money }}
        </template>
      </el-table-column>
      <el-table-column label="余额预警阈值" min-width="240" align="center">
        <template slot-scope="scope">
          <div class="tier-cell">
            <template v-if="tiersOf(scope.row).length">
              <el-tag
                v-for="t in tiersOf(scope.row)"
                :key="t"
                size="small"
                :type="tierTagType(scope.row, t)"
                class="tier-tag"
              >
                ≤ ¥{{ fmtTier(t) }}
              </el-tag>
            </template>
            <span v-else class="tier-empty">未设置</span>
            <el-button
              type="text"
              size="mini"
              class="tier-edit"
              @click="openTierDialog(scope.row)"
            >
              {{ tiersOf(scope.row).length ? '编辑' : '设置' }}
            </el-button>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="财务邮箱" min-width="200" align="center">
        <template slot-scope="scope">
          <div class="finance-email-cell">
            <el-tag
              v-if="scope.row.finance_email"
              type="primary"
              size="small"
              class="finance-email-tag"
            >
              {{ scope.row.finance_email }}
            </el-tag>
            <el-tag v-else type="info" size="small">未设置</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column
        class-name="status-col"
        label="状态"
        min-width="110"
        align="center"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.is_normal == 1" type="success">正常</el-tag>
          <el-tag v-else type="warning">禁用</el-tag>
        </template>
      </el-table-column>

      <el-table-column
        label="操作"
        align="center"
        min-width="300px"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <div class="ops-flex">
            <!-- 高频操作：常驻显示 -->
            <el-button
              size="mini"
              type="primary"
              @click="goToQuotaLog(scope.row)"
              >临时额度
            </el-button>
            <el-button
              size="mini"
              type="success"
              @click="openFinanceEmailDialog(scope.row)"
              >财务邮箱
            </el-button>
            <!-- 低频操作：收进「更多」 -->
            <el-dropdown
              trigger="click"
              size="mini"
              @command="handleMoreCommand($event, scope.row)"
            >
              <el-button size="mini">
                更多<i class="el-icon-arrow-down el-icon--right" />
              </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="$canEdit" command="accountLog"
                  >账户明细</el-dropdown-item
                >
                <el-dropdown-item command="quotaAccountLog"
                  >额度明细</el-dropdown-item
                >
                <el-dropdown-item v-if="$canEdit" command="recharge"
                  >充值余额</el-dropdown-item
                >
                <el-dropdown-item command="rechargeLog"
                  >充值记录</el-dropdown-item
                >
                <el-dropdown-item command="dataCount"
                  >财务统计</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination
        size="small"
        :current-page="listQuery.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="listQuery.limit"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <el-dialog
      title="充值"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-position="left"
        label-width="120px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="客户名称" prop="name">
          {{ currentRow?.name || '-' }}
        </el-form-item>
        <el-form-item label="金额" prop="money">
          <el-input v-model="form.money" />
        </el-form-item>
        <el-form-item label="实际充值时间" prop="actual_recharge_at">
          <el-date-picker v-model="form.actual_recharge_at" type="datetime" />
        </el-form-item>
        <el-form-item label="上传银行回单" prop="bank_receipts">
          <upload-list v-model="form.bank_receipts" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="常用信息修改"
      :visible.sync="dialogFormVisible1"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form1"
        :rules="rules1"
        :model="form1"
        label-position="left"
        label-width="150px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="购买方名称" prop="buyer_name">
          <el-input v-model="form1.buyer_name" />
        </el-form-item>
        <el-form-item label="购买方纳税人识别号" prop="buyer_taxpayer_no">
          <el-input v-model="form1.buyer_taxpayer_no" />
        </el-form-item>
        <el-form-item label="地址" prop="address">
          <el-input v-model="form1.address" />
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="form1.phone" />
        </el-form-item>
        <el-form-item label="开户行" prop="bank">
          <el-input v-model="form1.bank" />
        </el-form-item>
        <el-form-item label="纳税人资质" prop="taxpayer_qualification_type">
          <el-select v-model="form1.taxpayer_qualification_type">
            <el-option label="小微企业" :value="1" />
            <el-option label="一般纳税人" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="开票类型" prop="invoicing_type">
          <el-select v-model="form1.invoicing_type">
            <el-option label="普通发票" :value="1" />
            <el-option label="专用发票" :value="2" />
          </el-select>
        </el-form-item>
        <el-form-item label="发送邮箱" prop="email">
          <el-input v-model="form1.email" />
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form1.remark" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible1 = false">取消</el-button>
        <el-button type="primary" @click="saveData1" :loading="btnLoading1"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="请输入操作密码"
      :visible.sync="dialogVisible2"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form2"
        :rules="rules2"
        :model="form2"
        label-position="left"
        label-width="120px"
        style="width: 400px; margin-left: 50px"
      >
        <el-form-item label="操作密码" prop="password">
          <el-input v-model="form2.password" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取消</el-button>
        <el-button type="primary" @click="confirmPassword">确定</el-button>
      </span>
    </el-dialog>

    <!-- 余额预警阈值（阶梯）设置弹窗 -->
    <el-dialog
      title="余额预警阈值设置"
      :visible.sync="tierDialogVisible"
      :close-on-click-modal="false"
      width="480px"
    >
      <div v-if="tierRow" class="tier-dialog">
        <div class="tier-target">
          客户：<b>{{ tierRow.name }}</b>
          <span class="tier-balance">
            当前余额
            <b>¥{{ fmtTier(balanceOf(tierRow)) }}</b>
          </span>
        </div>

        <div class="tier-add">
          <el-input
            v-model="tierInput"
            size="small"
            placeholder="输入预警阈值金额，如 5000"
            @keyup.enter.native="handleAddTier"
          >
            <template slot="prepend">¥</template>
          </el-input>
          <el-button
            type="primary"
            size="small"
            class="tier-add__btn"
            @click="handleAddTier"
          >
            添加
          </el-button>
        </div>

        <div class="tier-list">
          <div class="tier-list__head">
            已添加 <b>{{ tierList.length }}</b> 档
            <span class="tier-list__hint"
              >（余额低于阈值时触发提醒，最多 5 档）</span
            >
          </div>
          <div v-if="!tierList.length" class="tier-list__empty">
            暂无阈值，请在上方输入金额后点击「添加」
          </div>
          <div v-for="(t, i) in tierList" :key="t" class="tier-list__item">
            <span class="tier-list__idx">{{ i + 1 }}</span>
            <el-tag :type="tierTagType(tierRow, t)" size="small"
              >≤ ¥{{ fmtTier(t) }}</el-tag
            >
            <el-button
              type="text"
              size="mini"
              class="tier-list__del"
              @click="handleRemoveTier(i)"
            >
              删除
            </el-button>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="tierDialogVisible = false"
          >取消</el-button
        >
        <el-button
          size="small"
          type="primary"
          :loading="tierSaving"
          @click="handleSaveTiers"
        >
          保存
        </el-button>
      </div>
    </el-dialog>

    <!-- 财务邮箱设置弹窗 -->
    <el-dialog
      title="财务邮箱设置"
      :visible.sync="financeEmailDialogVisible"
      :close-on-click-modal="false"
      width="460px"
    >
      <div v-if="financeEmailRow" class="fe-dialog">
        <div class="fe-target">
          客户：<b>{{ financeEmailRow.name }}</b>
          <span class="fe-tip">（请确认客户无误，对账账单将发送至此邮箱）</span>
        </div>
        <el-input
          v-model="financeEmailInput"
          size="small"
          placeholder="请输入财务邮箱，如 finance@example.com"
          clearable
          @keyup.enter.native="handleSaveFinanceEmail"
        />
        <div class="fe-note">
          用于发送对账单邮件。示例：胜意测试-山河颂2026-09账单
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="financeEmailDialogVisible = false"
          >取消</el-button
        >
        <el-button
          size="small"
          type="primary"
          :loading="financeEmailSaving"
          @click="handleSaveFinanceEmail"
        >
          保存
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from '@/utils/request'
import uploadList from '@/components/UploadList/index.vue'
import moment from 'moment'

export default {
  components: { uploadList },
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'gray',
        deleted: 'danger',
      }
      return statusMap[status]
    },
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        id: '',
        name: '',
        cooperation_type: '',
        is_normal: '',
      },
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '编辑',
        create: '添加',
      },
      form: {
        app_client_id: undefined,
        money: 0,
        actual_recharge_at: undefined,
        bank_receipts: [],
      },
      rules: {
        money: [
          { required: true, message: '充值金额不能为空', trigger: 'blur' },
        ],
        actual_recharge_at: [
          { required: true, message: '实际充值时间不能为空', trigger: 'blur' },
        ],
        bank_receipts: [
          { required: true, message: '请上传银行回单', trigger: 'change' },
        ],
      },
      btnLoading: false,
      dialogFormVisible1: false,
      dialogStatus1: '',
      textMap1: {
        update: '编辑',
        create: '添加',
      },
      form1: {
        app_client_id: '',
        buyer_name: undefined,
        buyer_taxpayer_no: undefined,
        address: undefined,
        phone: undefined,
        bank: undefined,
        taxpayer_qualification_type: undefined,
        invoicing_type: undefined,
        email: undefined,
        remark: undefined,
      },
      rules1: {
        buyer_name: [
          { required: true, message: '购买方名称不能为空', trigger: 'blur' },
        ],
        buyer_taxpayer_no: [
          {
            required: true,
            message: '购买方纳税人识别号不能为空',
            trigger: 'blur',
          },
        ],
      },
      btnLoading1: false,
      dialogVisible2: false,
      form2: {
        id: '',
        password: undefined,
      },
      rules2: {
        password: [
          { required: true, message: '操作密码不能为空', trigger: 'blur' },
        ],
      },
      currentRow: null,
      currentIndex: null,
      visibleSecrets: [],
      // 余额预警阈值（阶梯）设置弹窗
      tierDialogVisible: false,
      tierRow: null,
      tierInput: '',
      tierList: [],
      tierSaving: false,
      // 财务邮箱设置弹窗
      financeEmailDialogVisible: false,
      financeEmailRow: null,
      financeEmailInput: '',
      financeEmailSaving: false,
    }
  },
  created() {
    this.getList()
  },
  methods: {
    goToAccountLog(row) {
      this.$router.push({
        path: '/app-client/accountLog',
        query: {
          id: row.id,
          name: row.name,
        },
      })
    },
    goToQuotaLog(row) {
      this.$router.push({
        path: '/app-client/quotaLog',
        query: {
          id: row.id,
          name: row.name,
        },
      })
    },
    goToQuotaAccountLog(row) {
      this.$router.push({
        path: '/app-client/quotaAccountLog',
        query: {
          id: row.id,
          name: row.name,
        },
      })
    },
    goToRechargeLog(row) {
      this.$router.push({
        path: '/app-client/rechargeLog',
        query: {
          id: row.id,
          name: row.name,
        },
      })
    },
    goToDataCount(row) {
      this.$router.push({
        path: '/app-client/dataCount',
        query: {
          id: row.id,
          name: row.name,
        },
      })
    },
    openPasswordPrompt(index, row) {
      this.currentRow = row
      this.currentIndex = index
      this.form2.id = row.id
      this.dialogVisible2 = true
    },
    confirmPassword() {
      request({
        url: '/api/backend/app-client/get-secret',
        method: 'get',
        params: this.form2,
      }).then((response) => {
        this.$set(this.visibleSecrets, this.currentIndex, true)
        this.list[this.currentIndex].app_id = response.data.app_id
        this.list[this.currentIndex].app_secret = response.data.app_secret
        this.dialogVisible2 = false
      })
    },
    getList() {
      this.listLoading = true
      return request({
        url: '/api/backend/app-client/list',
        method: 'get',
        params: this.listQuery,
      }).then((response) => {
        this.list = response.data.data
        this.total = response.data.total
        this.listLoading = false
      })
    },
    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.listQuery.page = val
      this.getList()
    },
    // 操作列「更多」下拉分发
    handleMoreCommand(command, row) {
      switch (command) {
        case 'accountLog':
          this.goToAccountLog(row)
          break
        case 'quotaAccountLog':
          this.goToQuotaAccountLog(row)
          break
        case 'recharge':
          this.handleRecharge(row.id, row)
          break
        case 'rechargeLog':
          this.goToRechargeLog(row)
          break
        case 'dataCount':
          this.goToDataCount(row)
          break
        default:
          break
      }
    },

    // ================= 财务邮箱 =================
    openFinanceEmailDialog(row) {
      this.financeEmailRow = row
      this.financeEmailInput = row.finance_email || ''
      this.financeEmailDialogVisible = true
    },
    // 邮箱格式校验（允许一个或多个，逗号/分号分隔）
    isValidEmailList(str) {
      const list = String(str || '')
        .split(/[,;，；]/)
        .map((x) => x.trim())
        .filter(Boolean)
      if (!list.length) return false
      const re = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/
      return list.every((e) => re.test(e))
    },
    handleSaveFinanceEmail() {
      if (!this.financeEmailRow) return
      const val = String(this.financeEmailInput || '').trim()
      if (val && !this.isValidEmailList(val)) {
        this.$message.warning('请输入正确的邮箱地址')
        return
      }
      this.financeEmailSaving = true
      request({
        url: '/api/backend/app-client/store',
        method: 'post',
        data: {
          ...this.financeEmailRow,
          // 财务邮箱（需后端支持该字段）；空字符串表示清空
          finance_email: val,
        },
      })
        .then(() => this.getList())
        .then(() => {
          this.financeEmailDialogVisible = false
          this.$message({
            type: 'success',
            message: '财务邮箱已更新',
          })
        })
        .catch(() => {
          // 保存失败：保留弹窗便于重试，并明确提示（避免"点了没反应"）
          this.$message({
            type: 'error',
            message: '财务邮箱保存失败，请重试',
          })
        })
        .finally(() => {
          this.financeEmailSaving = false
        })
    },

    // ================= 余额预警阈值（阶梯） =================
    // 阈值档数上限
    tierMax() {
      return 5
    },
    // 读取某客户的阈值档位（从高到低）
    // 兼容：优先新字段 quota_warn_thresholds（数组），否则回退旧单值 quota_warn_threshold
    tiersOf(row) {
      if (!row) return []
      const arr = row.quota_warn_thresholds
      if (Array.isArray(arr) && arr.length) {
        return arr
          .map((v) => parseFloat(v))
          .filter((v) => !isNaN(v) && v > 0)
          .sort((a, b) => b - a)
      }
      const single = parseFloat(row.quota_warn_threshold)
      if (!isNaN(single) && single > 0) return [single]
      return []
    },
    // 客户当前余额（剩余额度 available_quota）；无法取值时返回 null
    balanceOf(row) {
      if (!row || !row.accounts) return null
      const v = parseFloat(row.accounts.available_quota)
      return isNaN(v) ? null : v
    },
    /**
     * 剩余额度显示级别（三态）
     *   green  ：余额 ≥ 最高阈值（正常）
     *   yellow ：最低阈值 ≤ 余额 < 最高阈值（进入预警区间）
     *   red    ：余额 < 最低阈值（低于最低档，红色呼吸示警）
     * 无阈值时：余额 > 0 → green；余额 ≤ 0 → red
     */
    balanceLevel(row) {
      const bal = this.balanceOf(row)
      if (bal === null) return 'green'
      const tiers = this.tiersOf(row) // 已按从高到低排序
      if (!tiers.length) {
        return bal <= 0 ? 'red' : 'green'
      }
      const maxT = tiers[0]
      const minT = tiers[tiers.length - 1]
      if (bal < minT) return 'red'
      if (bal < maxT) return 'yellow'
      return 'green'
    },
    // 余额是否已低于该档阈值 → 该档被触发（预警中）
    tierTriggered(row, threshold) {
      const bal = this.balanceOf(row)
      if (bal === null) return false
      const t = parseFloat(threshold)
      if (isNaN(t)) return false
      return bal < t
    },
    // 档位配色：默认蓝色；余额低于该档时标红
    tierTagType(row, threshold) {
      return this.tierTriggered(row, threshold) ? 'danger' : 'primary'
    },
    fmtTier(v) {
      const n = parseFloat(v)
      if (isNaN(n)) return '-'
      return n.toLocaleString('en-US')
    },
    openTierDialog(row) {
      this.tierRow = row
      this.tierInput = ''
      this.tierList = this.tiersOf(row).slice()
      this.tierDialogVisible = true
    },
    handleAddTier() {
      const v = parseFloat(this.tierInput)
      if (isNaN(v) || v <= 0) {
        this.$message.warning('请输入大于 0 的金额')
        return
      }
      if (this.tierList.indexOf(v) >= 0) {
        this.$message.warning('该阈值已存在')
        return
      }
      if (this.tierList.length >= this.tierMax) {
        this.$message.warning('最多 ' + this.tierMax + ' 档')
        return
      }
      this.tierList.push(v)
      this.tierList.sort((a, b) => b - a) // 从高到低
      this.tierInput = ''
    },
    handleRemoveTier(index) {
      this.tierList.splice(index, 1)
    },
    handleSaveTiers() {
      if (!this.tierRow) return
      this.tierSaving = true
      const thresholds = this.tierList.slice().sort((a, b) => b - a)
      request({
        url: '/api/backend/app-client/store',
        method: 'post',
        data: {
          ...this.tierRow,
          // 阶梯阈值数组（需后端支持该字段）
          quota_warn_thresholds: thresholds,
          // 兼容当前后端单值字段：取最高档，避免旧逻辑读到空
          quota_warn_threshold: thresholds.length ? thresholds[0] : 0,
        },
      })
        .then(() => this.getList())
        .then(() => {
          this.tierDialogVisible = false
          this.$message({
            type: 'success',
            message: '余额预警阈值已更新',
          })
        })
        .catch(() => {
          // 保存失败：保留弹窗便于重试，并明确提示
          this.$message({
            type: 'error',
            message: '余额预警阈值保存失败，请重试',
          })
        })
        .finally(() => {
          this.tierSaving = false
        })
    },
    resetForm() {
      this.form = {
        app_client_id: undefined,
        money: 0,
        actual_recharge_at: moment().format('YYYY-MM-DD HH:mm:ss'), // 默认当前时间
      }
      console.log(this.form)
      this.btnLoading = false
    },
    handleCreate() {
      this.resetForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = Object.assign(
        {
          imgArray: [
            'http://img.qkjcrm.com/c9fd9e7a-6e3c-42c7-8c9a-22c20cd3db22.png',
            'http://img.qkjcrm.com/f860dce0-04e4-49c4-926e-4a7a0360c8b0.png',
          ],
        },
        row,
      ) // copy obj
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    handleRecharge(id, row) {
      this.resetForm()
      this.currentRow = row
      this.form.app_client_id = id
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['form'].clearValidate()
      })
    },
    saveData() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.form.actual_recharge_at = moment(
            this.form.actual_recharge_at,
          ).format('YYYY-MM-DD HH:mm:ss')
          this.btnLoading = true
          request({
            url: '/api/backend/app-client-recharge/recharge',
            method: 'post',
            data: this.form,
          })
            .then((response) => {
              this.btnLoading = false
              this.dialogFormVisible = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })

              this.getList()
            })
            .catch((err) => {
              this.btnLoading = false
            })
        }
      })
    },
    handleUpdate1(row) {
      this.form1 = Object.assign({}, row.app_client_info) // copy obj
      this.form1.app_client_id = row.id
      this.dialogStatus1 = 'update'
      this.dialogFormVisible1 = true
      this.$nextTick(() => {
        this.$refs['form1'].clearValidate()
      })
    },
    saveData1() {
      this.$refs['form1'].validate((valid) => {
        if (valid) {
          this.btnLoading1 = true
          request({
            url: '/api/backend/app-client/store-info',
            method: 'post',
            data: this.form1,
          })
            .then((response) => {
              this.btnLoading1 = false
              this.dialogFormVisible1 = false
              this.$notify({
                title: '成功',
                message: '保存成功',
                type: 'success',
                duration: 2000,
              })
              this.getList()
            })
            .catch((err) => {
              this.btnLoading1 = false
            })
        }
      })
    },
    handleStatus(id, isNormal) {
      this.$confirm('此操作将修改客户端状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          request({
            url: '/api/backend/app-client/change-status',
            method: 'post',
            data: { id: id, is_normal: isNormal },
          }).then(() => {
            this.getList()
            this.$message({
              type: 'success',
              message: '操作成功!',
            })
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 6px;
}

/* ===== 剩余额度三态配色（正常绿 / 预警黄 / 低于最低档红+呼吸）===== */
.balance-tag.el-tag {
  min-width: 76px;
  border: none !important;
  color: #fff !important;
  font-weight: 600;
  text-align: center;
}

.balance-tag.el-tag.balance-green {
  background-color: #13ce66 !important;
}

.balance-tag.el-tag.balance-yellow {
  background-color: #ffba00 !important;
}

.balance-tag.el-tag.balance-red {
  background-color: #f56c6c !important;
  animation: balance-pulse 1.4s infinite;
}

/* 纯 box-shadow 涟漪扩散（对齐商旅客服「告警升级」标签效果）
   注意：不改变 opacity —— 早期版本用 opacity 1→0.5 呼吸会晃眼 */
@keyframes balance-pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(245, 108, 108, 0.7);
  }
  70% {
    box-shadow: 0 0 0 8px rgba(245, 108, 108, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(245, 108, 108, 0);
  }
}

/* ===== 操作列（商旅客服风格：高频常驻 + 低频收进「更多」）===== */
.ops-flex {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.ops-flex > .el-button,
.ops-flex > .el-dropdown {
  margin: 2px 4px;
}

/* 去掉 el-button 相邻自动加的左边距，避免与上面 margin 叠加 */
.ops-flex > .el-dropdown .el-button {
  margin-left: 0;
}

/* ===== 财务邮箱 ===== */
.finance-email-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}

.finance-email-tag {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fe-dialog {
  .fe-target {
    margin-bottom: 12px;
    font-size: 13px;
    color: #606266;

    b {
      color: #303133;
    }
  }

  .fe-tip {
    color: #909399;
    font-size: 12px;
  }

  .fe-note {
    margin-top: 8px;
    color: #909399;
    font-size: 12px;
  }
}

/* ===== 余额预警阈值（阶梯） ===== */
.tier-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  min-height: 24px;
}

.tier-tag {
  margin: 1px 4px 1px 0;
}

.tier-empty {
  color: #c0c4cc;
  font-size: 12px;
}

.tier-edit {
  margin-left: 4px;
  padding: 0;
}

.tier-dialog {
  .tier-target {
    margin-bottom: 12px;
    font-size: 13px;
    color: #606266;
  }

  .tier-balance {
    margin-left: 14px;
    color: #909399;

    b {
      color: #303133;
      font-weight: 600;
    }
  }

  .tier-add {
    display: flex;
    align-items: center;
  }

  .tier-add__btn {
    margin-left: 8px;
  }

  .tier-list {
    margin-top: 16px;

    &__head {
      margin-bottom: 8px;
      font-size: 13px;
      color: #303133;
    }

    &__hint {
      color: #909399;
      font-size: 12px;
      font-weight: 400;
    }

    &__empty {
      padding: 18px 0;
      border: 1px dashed #ebeef5;
      border-radius: 6px;
      color: #c0c4cc;
      font-size: 12px;
      text-align: center;
    }

    &__item {
      display: flex;
      align-items: center;
      padding: 7px 10px;
      margin-bottom: 6px;
      border: 1px solid #eef1f6;
      border-radius: 6px;
      background: #fafbfd;
    }

    &__idx {
      flex-shrink: 0;
      width: 18px;
      height: 18px;
      margin-right: 8px;
      border-radius: 50%;
      background: #eef1f6;
      color: #909399;
      font-size: 11px;
      line-height: 18px;
      text-align: center;
    }

    &__del {
      margin-left: auto;
      padding: 0;
      color: #f56c6c;
    }
  }
}
</style>
